import React, { useState } from 'react';
import menuSvg from "../../assets/img/icons/menu.svg";
import vikramshilaLogo from "../../assets/img/logos/vikramshilaLogo.png";
import { useNavigate } from "react-router-dom";
import {useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { SERVER_URL } from "../../config";
import { councilMembers } from "../../utils";
import {isMobile} from 'react-device-detect';
import MobileModalReg from "../../components/Modal/MobileMobleReg";

const Header = () => {
  const [mobileAlertReg, setMobileAlertReg] = useState(false);
  useEffect(() => {
    $(".menuToggle").click(function () {
      $(this).closest("header").find(".navWrap").toggleClass("active");
    });
  }, []);

  const isLoggedIn = useSelector(
    (state) => state?.LoginReducer?.userLoginDetails?.token ?? null
  );

  const navigate = useNavigate();
  const handleRedirect = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  const isCouncil = () => {
    const isCouncilPage =
      councilMembers.indexOf(window.location.pathname) > -1 ||
      window.location.pathname === "/council";
    return isCouncilPage ? "active" : "";
  };

  const isAdvisory = () => {
    const isAdvisoryPage =
      window.location.pathname.match("/member-details") ||
      window.location.pathname === "/advisory";
    return isAdvisoryPage && !isCouncil() ? "active" : "";
  };

  function checkTokenExpairation()
  {
      const currentTime = new Date().getTime();
      if(!localStorage.tokenExpireTime)
      return false;
      if(currentTime>=localStorage.tokenExpireTime)
      {
        const dispatch = useDispatch();
        localStorage.clear(); 
        dispatch({ type: "LOGOUT_STATUS_SUCCESS" });
         return false;
      }
      return true;
  }

  return (
    <>
    <header className="homepage__header">
      <a className="menuToggle">
        <img src={menuSvg} alt="#" />
      </a>
      <div className="cmyLogo">
        <a href={SERVER_URL} onClick={(e) => handleRedirect(e, "/")}>
          <img src={vikramshilaLogo} alt="#" />
        </a>
      </div>
      <div className="navWrap">
        <div className="navList">
          <nav>
            <ul>
              <li>
                <a
                  href="/"
                  onClick={(e) => handleRedirect(e, "/")}
                  className={window.location.pathname === "/" ? "active" : ""}
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/advisory"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={isAdvisory()}
                >
                  Advisory Board
                </a>
              </li>
              <li>
                <a
                  href="/council"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={isCouncil()}
                >
                  Academic Council
                </a>
              </li>
              <li>
                <a
                  href="/resourcecentre"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={
                    window.location.pathname === "/resourcecentre"
                      ? "active"
                      : ""
                  }
                >
                  Resource Centre
                </a>
              </li>
              <li>
                <a
                  href="/"
                  onClick={(e) => handleRedirect(e, "/about")}
                  className={
                    window.location.pathname === "/about" ? "active" : ""
                  }
                >
                  About
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="navSign">
        {(isLoggedIn && checkTokenExpairation())? null : (
          <a
            href="/login"
            onClick={(e) => handleRedirect(e, "/login")}
            className="signIn"
          >
            Login
          </a>
        )}
        {(isLoggedIn && checkTokenExpairation())? (
          <a
            href="/personaldetails"
            onClick={(e) => handleRedirect(e, "/myProfile")}
            className="signUp"
          >
            My Profile
          </a>
        ) : (
          <a
            // href="/registration"
            // onClick={(e) => handleRedirect(e, "/registration")}
            onClick={() =>isMobile ? setMobileAlertReg(true): navigate("/registration")}
            className="signUp"
          >
            Get Started Now!
          </a>
        )}
      </div>
    </header>
    <MobileModalReg mobileAlertReg={mobileAlertReg}
    setMobileAlertReg={setMobileAlertReg} />
    </>
  );
  
};

export default Header;
